import { render, staticRenderFns } from "./UserBankSettingWizard.vue?vue&type=template&id=150029c5&"
import script from "./UserBankSettingWizard.vue?vue&type=script&lang=js&"
export * from "./UserBankSettingWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports